<template>
	<div :class="['banner', `${type}`]">
		<div v-if="!slotExist" class="flex items-center gap-3">
			<div>
				<IconInfo :color_prop="iconColor" />
			</div>
			<div class="text-xs">{{ text }}</div>
		</div>

		<slot></slot>
	</div>
</template>

<script>
import IconInfo from './icons/IconInfo.vue'

export default {
	name: 'Banner',
	components: {
		IconInfo
	},

	props: {
		type: {
			type: 'info' | 'warning' | 'error' | 'success',
			default: 'info'
		},
		text: {
			type: String,
			default: 'Lorem Ipsum Dolor Sit Amet'
		},
		iconColor_prop: {
			type: 'info' | 'warning' | 'error' | 'success' | 'yellow',
			default: null
		}
	},
	data() {
		return {
		}
	},

	computed: {
		slotExist() {
			if (Object.keys(this.$slots).length > 0) {
				return true
			} else {
				return false
			}
		},

		iconColor() {
			const compare = this.iconColor_prop || this.type

			switch (compare) {
				case 'info':
					return getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
				case 'warning':
					return getComputedStyle(document.documentElement).getPropertyValue('--color-warning')
				case 'error':
					return getComputedStyle(document.documentElement).getPropertyValue('--color-error')
				case 'success':
					return getComputedStyle(document.documentElement).getPropertyValue('--color-success')
				case 'gold':
					return getComputedStyle(document.documentElement).getPropertyValue('--color-gold')
				default:
					return getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
			}
		}
	}
}
</script>

<style scoped>
.banner {
	background-color: var(--grey-1-color);
	color: white;
	padding: 1em;

	border: solid 1px;
	border-color: var(--color-theme);
	border-radius: 0.25rem;
}

.banner.success {
	border-color: var(--color-success);
}

.banner.error {
	border-color: var(--color-error);
}

.banner.warning {
	border-color: var(--color-warning);
}

.banner.info {
	border-color: var(--color-theme);
}
</style>